import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

import {environment} from './environments/environment';
import { OpenAPI } from '../../api/generated';

OpenAPI.BASE = environment.api.basePath;

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
